import { formatHourToTime } from "helper/appConstant";
import React, { memo } from "react";
import { FaRegClock } from "react-icons/fa6";

function HourSelect({
  value,
  onChange,
  boxTopMargin,
  height,
  isShowFullValue,
  label,
  isRequired,
  isNotIcon,
}) {
  return (
    <div
      className={`relative w-full ${boxTopMargin ? "boxTopMargin" : "mt-3"} `}
    >
      {label && (
        <label className="text-sm mb-1">
          {label}
          {isRequired && (
            <span className="text-red-500 ml-1 font-bold">*</span>
          )}{" "}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        className={`w-full ${
          height ? height : "h-12"
        } appearance-none py-3 px-2 bg-white text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:outline-none focus:ring-0 focus:border-[#2BACE2]`}
      >
        {Array.from({ length: 24 }).map((_, i) => (
          <option key={i} value={i} className=" w-40 ">
            {isShowFullValue ? formatHourToTime(i) : String(i).padStart(2, "0")}
          </option>
        ))}
      </select>

      {/* Icon */}
      {!isNotIcon && (
        <FaRegClock
          size={20}
          color="gray"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
        />
      )}
    </div>
  );
}

export default memo(HourSelect);
